import { render, staticRenderFns } from "./PreviewImageSave.vue?vue&type=template&id=d38ad0c6&scoped=true&"
import script from "./PreviewImageSave.vue?vue&type=script&lang=js&"
export * from "./PreviewImageSave.vue?vue&type=script&lang=js&"
import style0 from "./PreviewImageSave.vue?vue&type=style&index=0&id=d38ad0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38ad0c6",
  null
  
)

export default component.exports